import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('profile-Service');

export class ProfileService {

    constructor() {
        _apiClient = new ApiClient();
    }

    // Get RequestProfilePhotoUploadAsync
    public async RequestProfilePhotoUploadAsync(params: any) {
        if (params !== null) {
            return _apiClient.RequestAsync('POST', 'api/changeuserprofilephoto', { File: params }, token).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', T.t('r_profile_photo_update_error_notification'), 'topRight');
                    return null;
                } else {
                    Notification.setNotification('success', T.t('r_profile_photo_update_succesful_notification'), 'topRight');
                    return responseData.json();
                }
            }).then((result: any) => {
                return result;
            }).catch((response) => {
                return false;
            });
        }
    }

    // Get Profile data
    public async RequestGetProfileAsync(params: any) {
        if (params !== null) {
            return _apiClient.RequestAsync('POST', 'api/userprofileinformation', params, token).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', 'HATA RequestGetProfileAsync', 'topRight');
                    return null;
                } else {
                    return responseData.json();
                }
            }).then((result: any) => {
                return result;
            }).catch((response) => {
                return false;
            });
        }
    }

    // update profile data
    public async RequestUpdateProfileAsync(params: any) {
        if (params !== null) {
            return _apiClient.RequestAsync('PUT', 'api/user/profile', params, token).then((response: Response) => {
                return response;
            }).catch((response) => {
                return response;
            });
        }
    }

    // update password changes
    public async RequestChangePasswordAsync(params: any) {
        let errorList: any;
        if (params !== null) {
            return _apiClient.RequestAsync('POST', 'api/changeuserpassword', params, token).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    if (params.newPassword === null || params.newPassword === "") {
                        Notification.setNotification('error', T.t("r_componenet_input_required_message"), 'topRight');

                    }
                }
                return responseData.json();
            }).then((result: any) => {
                if (result === true) {
                    Notification.setNotification('success', T.t("r_change_password_success_message"), 'topRight');
                }
                else {
                    errorList = result;
                    if (errorList) {
                        Object.keys(errorList).forEach((key: any) => {
                            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                        })
                    }
                    else {
                        Notification.setNotification('error', T.t('r_change_password_error_message'), 'topRight');
                    }
                }
                return result;
            }).catch((error) => {
                Notification.setNotification('error', T.t('r_change_password_error_message') + error, 'topRight');
                return false;
            });
        }
    }

    // update password changes
    public async RequestChangePasswordQuestionAsync(params: any) {
        if (params !== null) {
            return _apiClient.RequestAsync('POST', 'api/CHANGEPASSWORDQUESTION_API_UCU_EKLENMELI', params, token).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', 'HATA RequestChangePasswordProfileAsync', 'topRight');
                    return null;
                } else {
                    return responseData.json();
                }
            }).then((result: any) => {
                if (result === true) {
                    Notification.setNotification('success', 'Güvenlik sorusu başarıyla güncellendi.', 'topRight');
                }
                return result;
            }).catch((response) => {
                Notification.setNotification('error', 'Güvenlik sorusu guncellenemedi - 2', 'topRight');
                return false;
            });
        }
    }

    public async RequestGetPreferencesAsync() {
        return _apiClient.RequestAsync('GET', 'api/user/preference').then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestSetPreferencesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/user/preference', params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((responseData) => {
            return responseData;
        });
    }
    public async RequestSetLanguage(params: any) {
        return _apiClient.RequestAsync('POST', 'api/user/changelanguage', params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((responseData) => {
            return responseData;
        });
    }

    // Get timezone data
    public async RequestGetTimezoneData(params: any) {
        if (params !== null) {
            return _apiClient.RequestAsync('GET', 'api/organization/gettimezones', token).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', 'HATA RequestGetTimezoneData', 'topRight');
                    return null;
                } else {
                    return responseData.json();
                }
            }).then((result: any) => {
                return result;
            }).catch((response) => {
                return false;
            });
        }
    }
}

